import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { InvoiceLineItem } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import styles from "./ItemCell.module.scss";

export const ItemCell = memo(
    ({ row }: CellContext<ViewTableFeatures, InvoiceLineItem, unknown>) => {
        const lineItem = row.original;
        const itemName = lineItem.nativeDetail?.productOrService ?? null;
        const hasItemName = (itemName ?? "").trim().length > 0;

        return (
            <ViewTableCell className={styles.item}>
                {hasItemName ? itemName : null}
            </ViewTableCell>
        );
    },
);
